import { Constants } from "./constants";

const ElementRunningTimes: any = {
  [Constants.sanctioning_club.AKC]: {
    [Constants.show_type.rally_obedience]: {
      [Constants.dog_class_element_level.novice_a]:
        Constants.running_order_times.AKC.rally_obedience.novice_a,
      [Constants.dog_class_element_level.novice_b]:
        Constants.running_order_times.AKC.rally_obedience.novice_b,
      [Constants.dog_class_element_level.intermediate]:
        Constants.running_order_times.AKC.rally_obedience.intermediate,
      [Constants.dog_class_element_level.advanced_a]:
        Constants.running_order_times.AKC.rally_obedience.advanced_a,
      [Constants.dog_class_element_level.advanced_b]:
        Constants.running_order_times.AKC.rally_obedience.advanced_b,
      [Constants.dog_class_element_level.excellent_a]:
        Constants.running_order_times.AKC.rally_obedience.excellent_a,
      [Constants.dog_class_element_level.excellent_b]:
        Constants.running_order_times.AKC.rally_obedience.excellent_b,
      [Constants.dog_class_element_level.master]:
        Constants.running_order_times.AKC.rally_obedience.master,
      [Constants.dog_class_element_level.choice]:
        Constants.running_order_times.AKC.rally_obedience.choice,
      [Constants.dog_class_element_level.pairs]:
        Constants.running_order_times.AKC.rally_obedience.pairs,
      [Constants.dog_class_element_level.novice_pairs]:
        Constants.running_order_times.AKC.rally_obedience.novice_pairs,
      [Constants.dog_class_element_level.advanced_pairs]:
        Constants.running_order_times.AKC.rally_obedience.advanced_pairs,
      [Constants.dog_class_element_level.team]:
        Constants.running_order_times.AKC.rally_obedience.team,
      [Constants.dog_class_element_level.novice_teams]:
        Constants.running_order_times.AKC.rally_obedience.novice_teams,
      [Constants.dog_class_element_level.advanced_teams]:
        Constants.running_order_times.AKC.rally_obedience.advanced_teams,
    },
    [Constants.show_type.obedience]: {
      [Constants.dog_class_element_level.pre_novice]:
        Constants.running_order_times.AKC.obedience.pre_novice,
      [Constants.dog_class_element_level.beginner_novice]:
        Constants.running_order_times.AKC.obedience.beginner_novice,
      [Constants.dog_class_element_level.beginner_novice_a]:
        Constants.running_order_times.AKC.obedience.beginner_novice_a,
      [Constants.dog_class_element_level.beginner_novice_b]:
        Constants.running_order_times.AKC.obedience.beginner_novice_b,
      [Constants.dog_class_element_level.preferred_novice]:
        Constants.running_order_times.AKC.obedience.preferred_novice,
      [Constants.dog_class_element_level.novice_a]:
        Constants.running_order_times.AKC.obedience.novice_a,
      [Constants.dog_class_element_level.novice_b]:
        Constants.running_order_times.AKC.obedience.novice_b,
      [Constants.dog_class_element_level.novice_c]:
        Constants.running_order_times.AKC.obedience.novice_c,
      [Constants.dog_class_element_level.advance_novice]:
        Constants.running_order_times.AKC.obedience.advance_novice,
      [Constants.dog_class_element_level.graduate_novice]:
        Constants.running_order_times.AKC.obedience.graduate_novice,
      [Constants.dog_class_element_level.open_a]:
        Constants.running_order_times.AKC.obedience.open_a,
      [Constants.dog_class_element_level.open_b]:
        Constants.running_order_times.AKC.obedience.open_b,
      [Constants.dog_class_element_level.advance_open]:
        Constants.running_order_times.AKC.obedience.advance_open,
      [Constants.dog_class_element_level.preferred_open]:
        Constants.running_order_times.AKC.obedience.preferred_open,
      [Constants.dog_class_element_level.graduate_open]:
        Constants.running_order_times.AKC.obedience.graduate_open,
      [Constants.dog_class_element_level.preferred_graduate_open]:
        Constants.running_order_times.AKC.obedience.preferred_graduate_open,
      [Constants.dog_class_element_level.utility_a]:
        Constants.running_order_times.AKC.obedience.utility_a,
      [Constants.dog_class_element_level.utility_b]:
        Constants.running_order_times.AKC.obedience.utility_b,
      [Constants.dog_class_element_level.preferred_utility]:
        Constants.running_order_times.AKC.obedience.preferred_utility,
      [Constants.dog_class_element_level.wc_novice]:
        Constants.running_order_times.AKC.obedience.wc_novice,
      [Constants.dog_class_element_level.wc_open]:
        Constants.running_order_times.AKC.obedience.wc_open,
      [Constants.dog_class_element_level.wc_utility]:
        Constants.running_order_times.AKC.obedience.wc_utility,
      [Constants.dog_class_element_level.udx]:
        Constants.running_order_times.AKC.obedience.udx,
      [Constants.dog_class_element_level.versatility]:
        Constants.running_order_times.AKC.obedience.versatility,
      [Constants.dog_class_element_level.veteran]:
        Constants.running_order_times.AKC.obedience.veteran,
      [Constants.dog_class_element_level.brace]:
        Constants.running_order_times.AKC.obedience.brace,
      [Constants.dog_class_element_level.team]:
        Constants.running_order_times.AKC.obedience.team,
    },
    [Constants.show_type.scentwork]: {
      [Constants.dog_class_element.scentwork_container]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.scentwork_interior]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 6.5,
        [Constants.dog_class_element_level.scentwork_master]: 8,
      },
      [Constants.dog_class_element.scentwork_exterior]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.scentwork_buried]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.scentwork_handler_disc]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.scentwork_detective]: {
        [Constants.dog_class_element_level.scentwork_detective]: 10,
      },
    },
    [Constants.show_type.conformation]: {
      [Constants.dog_class_element_level.akc_4_6_month_puppy]: 2.4,
      [Constants.dog_class_element_level.akc_6_9_month_puppy]: 2.4,
      [Constants.dog_class_element_level.akc_9_12_month_puppy]: 2.4,
      [Constants.dog_class_element_level.akc_12_15_month_puppy]: 2.4,
      [Constants.dog_class_element_level.akc_15_18_month_puppy]: 2.4,
      [Constants.dog_class_element_level.akc_12_18_month_puppy]: 2.4,
      [Constants.dog_class_element_level.akc_18_24_month_puppy]: 2.4,
      [Constants.dog_class_element_level.akc_under_12_month_bred_by_exhibitor]: 2.4,
      [Constants.dog_class_element_level.akc_adult_bred_by_exhibitor]: 2.4,
      [Constants.dog_class_element_level.akc_amateur_owner_handler]: 2.4,
      [Constants.dog_class_element_level.akc_american_bred]: 2.4,
      [Constants.dog_class_element_level.akc_open]: 2.4,
      [Constants.dog_class_element_level.akc_novice]: 2.4,
      [Constants.dog_class_element_level.akc_miscellaneous]: 2.4,
      [Constants.dog_class_element_level.akc_best_of_breed]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_6_8_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_8_10_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_8_11_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_10_12_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_11_plus_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_7_plus_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_8_plus_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_10_plus_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_13_plus_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_7_10_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_7_9_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_9_plus_years]: 2.4,
      [Constants.dog_class_element_level.akc_veteran_12_plus_years]: 2.4,
      [Constants.dog_class_element.junior_showmanship]: 2.4,
      [Constants.dog_class_element_level.akc_coursing]: 2.4,
      [Constants.dog_class_element_level.akc_stud_dog]: 2.4,
      [Constants.dog_class_element_level.akc_brace]: 2.4,
      [Constants.dog_class_element_level.akc_futurity]: 2.4,
      [Constants.dog_class_element_level.akc_brood_bitch]: 2.4,
      [Constants.dog_class_element.conformation_non_licensed]: {
        [Constants.dog_class_element_level.akc_puppy_sweepstakes]: 2.4,
        [Constants.dog_class_element_level.akc_puppy_sweepstakes_6_9]: 2.4,
        [Constants.dog_class_element_level.akc_puppy_sweepstakes_9_12]: 2.4,
        [Constants.dog_class_element_level.akc_puppy_sweepstakes_12_18]: 2.4,
        [Constants.dog_class_element_level.akc_puppy_sweepstakes_12_15]: 2.4,
        [Constants.dog_class_element_level.akc_puppy_sweepstakes_15_18]: 2.4,
        [Constants.dog_class_element_level.akc_puppy_sweepstakes_bred_by_exhibitor_6_18]: 2.4,
        [Constants.dog_class_element_level.akc_puppy_sweepstakes_18_24]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_7_10]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_8_10]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_8_11]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_10_12]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_11_plus]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_10_13]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_10_plus]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_12_plus]: 2.4,
        [Constants.dog_class_element_level.akc_veteran_sweepstakes_13_plus]: 2.4,
        [Constants.dog_class_element_level.akc_dual_title_sweepstakes_6m_7y]: 2.4,
        [Constants.dog_class_element_level.akc_dual_title_sweepstakes_7y_plus]: 2.4,
        [Constants.dog_class_element_level.akc_dual_title_sweepstakes_7y_11y]: 2.4,
        [Constants.dog_class_element_level.akc_dual_title_sweepstakes_10y_plus]: 2.4,
        [Constants.dog_class_element_level.akc_dual_title_sweepstakes_11y_plus]: 2.4,
        [Constants.dog_class_element_level.akc_sled_dog]: 2.4,
        [Constants.dog_class_element_level.akc_hunting_class]: 2.4,
        [Constants.dog_class_element_level.akc_field_trial_class]: 2.4,
        [Constants.dog_class_element_level.akc_teams]: 2.4,
        [Constants.dog_class_element_level.akc_parade_of_titleholders]: 2.4,
        [Constants.dog_class_element_level.akc_best_head]: 2.4,
        [Constants.dog_class_element_level.akc_best_movement]: 2.4,
        [Constants.dog_class_element_level.akc_best_field]: 2.4,
      },
    },
    [Constants.show_type.fast_cat]: {
      [Constants.dog_class_element.fast_cat]: 3,
    },
    [Constants.show_type.fetch]: {
      [Constants.dog_class_element_level.novice]: 5,
      [Constants.dog_class_element_level.intermediate]: 5,
      [Constants.dog_class_element_level.advanced]: 5,
      [Constants.dog_class_element_level.retriever]: 5,
    },
    [Constants.show_type.agility]: {
      [Constants.dog_class_element.standard]: {
        [Constants.dog_class_element_level.novice_a]: 2,
        [Constants.dog_class_element_level.novice_b]: 2,
        [Constants.dog_class_element_level.akc_open]: 1.75,
        [Constants.dog_class_element_level.excellent]: 1.5,
        [Constants.dog_class_element_level.master]: 1.5,
        [Constants.dog_class_element_level.novice_preferred]: 2,
        [Constants.dog_class_element_level.open_preferred]: 1.75,
        [Constants.dog_class_element_level.excellent_preferred]: 1.5,
        [Constants.dog_class_element_level.master_preferred]: 1.5,
      },
      [Constants.dog_class_element.jumpers_with_weaves]: {
        [Constants.dog_class_element_level.novice_a]: 1.5,
        [Constants.dog_class_element_level.novice_b]: 1.5,
        [Constants.dog_class_element_level.akc_open]: 1.25,
        [Constants.dog_class_element_level.excellent]: 1,
        [Constants.dog_class_element_level.master]: 1,
        [Constants.dog_class_element_level.novice_preferred]: 1.5,
        [Constants.dog_class_element_level.open_preferred]: 1.25,
        [Constants.dog_class_element_level.excellent_preferred]: 1,
        [Constants.dog_class_element_level.master_preferred]: 1,
      },
      [Constants.dog_class_element.fast]: {
        [Constants.dog_class_element_level.novice_a]: 1.5,
        [Constants.dog_class_element_level.novice_b]: 1.5,
        [Constants.dog_class_element_level.akc_open]: 1.5,
        [Constants.dog_class_element_level.excellent]: 1.25,
        [Constants.dog_class_element_level.master]: 1.25,
        [Constants.dog_class_element_level.novice_preferred]: 1.5,
        [Constants.dog_class_element_level.open_preferred]: 1.5,
        [Constants.dog_class_element_level.excellent_preferred]: 1.25,
        [Constants.dog_class_element_level.master_preferred]: 1.25,
      },
      [Constants.dog_class_element.t2b]: {
        [Constants.dog_class_element_level.t2b]: 1.25,
        [Constants.dog_class_element_level.t2b_preferred]: 1.25,
      },
      [Constants.dog_class_element.premier_standard]: {
        [Constants.dog_class_element_level.premier_standard]: 1.5,
        [Constants.dog_class_element_level.premier_standard_preferred]: 1.5,
      },
      [Constants.dog_class_element.premier_jww]: {
        [Constants.dog_class_element_level.premier_jww]: 1.5,
        [Constants.dog_class_element_level.premier_jww_preferred]: 1.5,
      },
    },
    // NOTE: Placeholder estimates - adjust as needed, no code changes required.
    [Constants.show_type.herding]: {
      [Constants.dog_class_element_level.started]: 10,
      [Constants.dog_class_element_level.intermediate]: 12,
      [Constants.dog_class_element_level.advance]: 15,
    },
    [Constants.show_type.pre_trial_herding]: {
      [Constants.dog_class_section.sheep]: 8,
      [Constants.dog_class_section.cattle]: 8,
      [Constants.dog_class_section.ducks]: 8,
    },
    [Constants.show_type.instinct_test_herding]: {
      [Constants.dog_class_section.sheep]: 5,
      [Constants.dog_class_section.cattle]: 5,
      [Constants.dog_class_section.ducks]: 5,
    },
  },
  [Constants.sanctioning_club.UKC]: {
    [Constants.show_type.nosework]: {
      [Constants.dog_class_element.nosework_container]: {
        [Constants.dog_class_element_level.novice]: 2.5,
        [Constants.dog_class_element_level.advanced]: 3,
        [Constants.dog_class_element_level.superior]: 3,
        [Constants.dog_class_element_level.master]: 4,
        [Constants.dog_class_element_level.elite]: 4.5,
      },   
      [Constants.dog_class_element.nosework_exterior]: {
        [Constants.dog_class_element_level.novice]: 2.5,
        [Constants.dog_class_element_level.advanced]: 3,
        [Constants.dog_class_element_level.superior]: 3,
        [Constants.dog_class_element_level.master]: 4,
        [Constants.dog_class_element_level.elite]: 4.5,
      },   
      [Constants.dog_class_element.nosework_interior]: {
        [Constants.dog_class_element_level.novice]: 2.5,
        [Constants.dog_class_element_level.advanced]: 3,
        [Constants.dog_class_element_level.superior]: 3,
        [Constants.dog_class_element_level.master]: 4,
        [Constants.dog_class_element_level.elite]: 4.5,
      },   
      [Constants.dog_class_element.nosework_vehicle]: {
        [Constants.dog_class_element_level.novice]: 2.5,
        [Constants.dog_class_element_level.advanced]: 3,
        [Constants.dog_class_element_level.superior]: 3,
        [Constants.dog_class_element_level.master]: 4,
        [Constants.dog_class_element_level.elite]: 4.5,
      },   
      [Constants.dog_class_element.nosework_handler_descrimination]: {
        [Constants.dog_class_element_level.novice]: 1,
        [Constants.dog_class_element_level.advanced]: 1,
        [Constants.dog_class_element_level.excellent]: 1,
        [Constants.dog_class_element_level.master]: 2,
      },   
    },
    [Constants.show_type.obedience]: {
      [Constants.dog_class_element_level.pre_novice]: 5,
      [Constants.dog_class_element_level.beginner_novice]: 6,
      [Constants.dog_class_element_level.novice_a]: 7,
      [Constants.dog_class_element_level.novice_b]: 7,
      [Constants.dog_class_element_level.novice_c]: 7,
      [Constants.dog_class_element_level.advance_novice]: 8,
      [Constants.dog_class_element_level.open_a]: 8,
      [Constants.dog_class_element_level.open_b]: 8,
      [Constants.dog_class_element_level.advance_open]: 9,
      [Constants.dog_class_element_level.utility_a]: 9,
      [Constants.dog_class_element_level.utility_b]: 9,
      [Constants.dog_class_element_level.uudx]: 17,
      [Constants.dog_class_element_level.brace]: 5,
      [Constants.dog_class_element_level.team]: 5,
      [Constants.dog_class_element_level.veteran]: 5,
    },
    [Constants.show_type.rally_obedience]: {
      // Canonical levels (section stored separately)
      [Constants.dog_class_element_level.ro1]: 3.33,
      [Constants.dog_class_element_level.ro2]: 3.33,
      [Constants.dog_class_element_level.ro3]: 3.33,
      [Constants.dog_class_element_level.rom]: 3.33, // Rally Master default when the club has not set one
      // Legacy "RO1 A" style levels
      [Constants.dog_class_element_level.ro1_a]: 3.33,
      [Constants.dog_class_element_level.ro1_b]: 3.33,
      [Constants.dog_class_element_level.ro1_c]: 3.33,
      [Constants.dog_class_element_level.ro2_a]: 3.33,
      [Constants.dog_class_element_level.ro2_b]: 3.33,
      [Constants.dog_class_element_level.ro3_a]: 3.33,
      [Constants.dog_class_element_level.ro3_b]: 3.33,
      [Constants.dog_class_element_level.rom_a]: 3.33,
      [Constants.dog_class_element_level.rom_b]: 3.33,
      [Constants.dog_class_element_level.urx]: 6.66,
      [Constants.dog_class_element_level.rmx]: 9.99,
    },
    [Constants.show_type.shed_dog]: {
      [Constants.dog_class_element_level.working_shed_dog]: 5,
      [Constants.dog_class_element_level.shed_dog_champion]: 5,
      [Constants.dog_class_element_level.shed_dog_youth]: 5,
    },
    [Constants.show_type.conformation]: 4.0, // 4.0 minutes per dog for UKC Conformation
    // NOTE: Placeholder estimates - adjust as needed, no code changes required.
    [Constants.show_type.precision_coursing]: {
      [Constants.dog_class_element_level.novice]: 3,
      [Constants.dog_class_element_level.advanced]: 3,
      [Constants.dog_class_element_level.superior]: 3,
      [Constants.dog_class_element_level.master]: 3,
      [Constants.dog_class_element_level.elite]: 3,
      [Constants.dog_class_element_level.dash]: 1.5,
      [Constants.dog_class_element_level.steeplechase]: 1.5,
      [Constants.dog_class_element_level.fun_run]: 2,
      [Constants.dog_class_element_level.puppy_dash]: 2,
    },
  },
  [Constants.sanctioning_club.CKC]: {
    // CKC Conformation Show Rules 3.4.4: 2 1/2 minutes per dog for judge load limits
    [Constants.show_type.conformation]: 2.5,
    [Constants.show_type.obedience]: {
      [Constants.dog_class_element_level.pre_novice]:
        Constants.running_order_times.CKC.obedience.pre_novice,
      [Constants.dog_class_element_level.novice_a]:
        Constants.running_order_times.CKC.obedience.novice_a,
      [Constants.dog_class_element_level.novice_b]:
        Constants.running_order_times.CKC.obedience.novice_b,
      [Constants.dog_class_element_level.novice_c]:
        Constants.running_order_times.CKC.obedience.novice_c,
      [Constants.dog_class_element_level.ckc_novice_intermediate]:
        Constants.running_order_times.CKC.obedience.ckc_novice_intermediate,
      [Constants.dog_class_element_level.open_a]:
        Constants.running_order_times.CKC.obedience.open_a,
      [Constants.dog_class_element_level.open_b]:
        Constants.running_order_times.CKC.obedience.open_b,
      [Constants.dog_class_element_level.utility_a]:
        Constants.running_order_times.CKC.obedience.utility_a,
      [Constants.dog_class_element_level.utility_b]:
        Constants.running_order_times.CKC.obedience.utility_b,
      [Constants.dog_class_element_level.ckc_exhibition_only]:
        Constants.running_order_times.CKC.obedience.ckc_exhibition_only,
      [Constants.dog_class_element_level.wc_novice]:
        Constants.running_order_times.CKC.obedience.wc_novice,
      [Constants.dog_class_element_level.wc_open]:
        Constants.running_order_times.CKC.obedience.wc_open,
      [Constants.dog_class_element_level.wc_utility]:
        Constants.running_order_times.CKC.obedience.wc_utility,
      [Constants.dog_class_element_level.brace]:
        Constants.running_order_times.CKC.obedience.brace,
      [Constants.dog_class_element_level.team]:
        Constants.running_order_times.CKC.obedience.team,
      [Constants.dog_class_element_level.veteran]:
        Constants.running_order_times.CKC.obedience.veteran,
      [Constants.dog_class_element_level.graduate_novice]:
        Constants.running_order_times.CKC.obedience.graduate_novice,
      [Constants.dog_class_element_level.graduate_open]:
        Constants.running_order_times.CKC.obedience.graduate_open,
      [Constants.dog_class_element_level.ckc_pre_open]:
        Constants.running_order_times.CKC.obedience.ckc_pre_open,
      [Constants.dog_class_element_level.ckc_pre_utility]:
        Constants.running_order_times.CKC.obedience.ckc_pre_utility,
    },
    [Constants.show_type.rally_obedience]: {
      [Constants.dog_class_element_level.novice_a]:
        Constants.running_order_times.CKC.rally_obedience.novice_a,
      [Constants.dog_class_element_level.novice_b]:
        Constants.running_order_times.CKC.rally_obedience.novice_b,
      [Constants.dog_class_element_level.intermediate]:
        Constants.running_order_times.CKC.rally_obedience.intermediate,
      [Constants.dog_class_element_level.advanced_a]:
        Constants.running_order_times.CKC.rally_obedience.advanced_a,
      [Constants.dog_class_element_level.advanced_b]:
        Constants.running_order_times.CKC.rally_obedience.advanced_b,
      [Constants.dog_class_element_level.excellent_a]:
        Constants.running_order_times.CKC.rally_obedience.excellent_a,
      [Constants.dog_class_element_level.excellent_b]:
        Constants.running_order_times.CKC.rally_obedience.excellent_b,
      [Constants.dog_class_element_level.master]:
        Constants.running_order_times.CKC.rally_obedience.master,
      [Constants.dog_class_element_level.ckc_exhibition_only]:
        Constants.running_order_times.CKC.rally_obedience.ckc_exhibition_only,
      [Constants.dog_class_element_level.brace]:
        Constants.running_order_times.CKC.rally_obedience.brace,
      [Constants.dog_class_element_level.team]:
        Constants.running_order_times.CKC.rally_obedience.team,
    },
    [Constants.show_type.scent_detection]: {
      [Constants.dog_class_element.scent_detection_container]: {
        [Constants.dog_class_element_level.scent_detection_instinct]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_container.scent_detection_instinct,
        [Constants.dog_class_element_level.scent_detection_novice]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_container.scent_detection_novice,
        [Constants.dog_class_element_level.scent_detection_open]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_container.scent_detection_open,
        [Constants.dog_class_element_level.scent_detection_excellent]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_container.scent_detection_excellent,
        [Constants.dog_class_element_level.scent_detection_master]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_container.scent_detection_master,
      },
      [Constants.dog_class_element.scent_detection_interior]: {
        [Constants.dog_class_element_level.scent_detection_novice]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_interior.scent_detection_novice,
        [Constants.dog_class_element_level.scent_detection_open]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_interior.scent_detection_open,
        [Constants.dog_class_element_level.scent_detection_excellent]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_interior.scent_detection_excellent,
        [Constants.dog_class_element_level.scent_detection_master]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_interior.scent_detection_master,
      },
      [Constants.dog_class_element.scent_detection_exterior]: {
        [Constants.dog_class_element_level.scent_detection_novice]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_exterior.scent_detection_novice,
        [Constants.dog_class_element_level.scent_detection_open]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_exterior.scent_detection_open,
        [Constants.dog_class_element_level.scent_detection_excellent]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_exterior.scent_detection_excellent,
        [Constants.dog_class_element_level.scent_detection_master]:
          Constants.running_order_times.CKC.scent_detection.scent_detection_exterior.scent_detection_master,
      },
    },
  },
  [Constants.sanctioning_club.PWDCA]: {
    [Constants.show_type.water_dog]: {
      [Constants.dog_class_element_level.junior_water_dog]: 10,
      [Constants.dog_class_element_level.apprentice]: 15,
      [Constants.dog_class_element_level.working]: 15,
      [Constants.dog_class_element_level.courier]: 20,
      [Constants.dog_class_element_level.master]: 20,
    },
  },
  [Constants.sanctioning_club.ABI]: {
    [Constants.show_type.country_rat_race]: {
      [Constants.dog_class_element_level.cubs]: 10,
      [Constants.dog_class_element_level.scouts]: 10,
      [Constants.dog_class_element_level.huntsman]: 10,
      [Constants.dog_class_element_level.huntsmaster]: 10,
      [Constants.dog_class_element_level.field_master]: 10,
    },
    [Constants.show_type.lost_and_found]: {
      [Constants.dog_class_element.lf_containers]: {
        [Constants.dog_class_element_level.seeker]: 10,
        [Constants.dog_class_element_level.locater]: 10,
        [Constants.dog_class_element_level.discover]: 10,
      },
      [Constants.dog_class_element.lf_interiors]: {
        [Constants.dog_class_element_level.seeker]: 10,
        [Constants.dog_class_element_level.locater]: 10,
        [Constants.dog_class_element_level.discover]: 10,
      },
      [Constants.dog_class_element.lf_exteriors]: {
        [Constants.dog_class_element_level.seeker]: 10,
        [Constants.dog_class_element_level.locater]: 10,
        [Constants.dog_class_element_level.discover]: 10,
      },
    },
    [Constants.show_type.scent_dog_games]: {
      [Constants.dog_class_element_level.sdg_once_around]: 5,
      [Constants.dog_class_element_level.sdg_double_or_nothing]: 5,
      [Constants.dog_class_element_level.sdg_clear_it]: 5,
      [Constants.dog_class_element_level.sdg_duo]: 5,
      [Constants.dog_class_element_level.sdg_teams]: 5,
      [Constants.dog_class_element_level.sdg_against_odds]: 5,
      [Constants.dog_class_element_level.sdg_hi_lo]: 5,
      [Constants.dog_class_element_level.sdg_double_0_7]: 5,
      [Constants.dog_class_element_level.sdg_at_distance]: 5,
      [Constants.dog_class_element_level.sdg_relay_race]: 5,
      [Constants.dog_class_element_level.sdg_cluster]: 5,
      [Constants.dog_class_element_level.sdg_hit_the_wall]: 5,
      [Constants.dog_class_element_level.sdg_twice_around_foundations]: 5,
      [Constants.dog_class_element_level.sdg_clear_it_foundations]: 5,
      [Constants.dog_class_element_level.sdg_cluster_foundations]: 5,
      [Constants.dog_class_element_level.sdg_hi_lo_foundations]: 5,
      [Constants.dog_class_element_level.sdg_hit_the_wall_foundations]: 5,
    },
  },
  [Constants.sanctioning_club.GENERAL]: {
    [Constants.show_type.sniff_n_go]: {
      [Constants.dog_class_element_level.one_hide_birch]: 5,
      [Constants.dog_class_element_level.two_hides_birch_anise]: 5,
      [Constants.dog_class_element_level.three_hides_birch_anise_clove]: 5,
      [Constants.dog_class_element_level.new_to_nosework]: 5,
    },
    [Constants.show_type.dock_diving]: {
      [Constants.dog_class_element.dock_diving]: 5,
    },
    [Constants.show_type.obedience_show_n_go]: {
      [Constants.dog_class_element_level.obedience_show_n_go_beginner_novice]: 5,
      [Constants.dog_class_element_level.obedience_show_n_go_novice]: 5,
      [Constants.dog_class_element_level.obedience_show_n_go_open]: 5,
      [Constants.dog_class_element_level.obedience_show_n_go_utility]: 5,
    },
    [Constants.show_type.general_rally]: {
      [Constants.dog_class_element_level.general_rally_novice]: 3,
      [Constants.dog_class_element_level.general_rally_intermediate]: 3,
      [Constants.dog_class_element_level.general_rally_advanced]: 3,
      [Constants.dog_class_element_level.general_rally_excellent]: 3,
      [Constants.dog_class_element_level.general_rally_master]: 3,
      [Constants.dog_class_element_level.general_rally_choice]: 3,
    },
  },
  [Constants.sanctioning_club.C_WAGS]: {
    [Constants.show_type.scent]: {
      // Scent element levels - 5 minutes each
      [Constants.dog_class_element_level.patrols_1]: 5,
      [Constants.dog_class_element_level.detective_2]: 5,
      [Constants.dog_class_element_level.investigator_3]: 5,
      [Constants.dog_class_element_level.super_sleuth_4]: 5,
      [Constants.dog_class_element_level.private_investigator]: 5,
      [Constants.dog_class_element_level.detective_diversions]: 5,
      // Ranger element levels - 5 minutes each
      [Constants.dog_class_element_level.scent_ranger_1]: 5,
      [Constants.dog_class_element_level.scent_ranger_2]: 5,
      [Constants.dog_class_element_level.scent_ranger_3]: 5,
      [Constants.dog_class_element_level.scent_ranger_4]: 5,
      [Constants.dog_class_element_level.scent_ranger_5]: 5,
      // Dasher element levels - 5 minutes each
      [Constants.dog_class_element_level.dasher_scent_3]: 5,
      [Constants.dog_class_element_level.dasher_scent_4]: 5,
      [Constants.dog_class_element_level.dasher_scent_5]: 5,
      [Constants.dog_class_element_level.dasher_scent_6]: 5,
    },
    [Constants.show_type.obedience]: {
      // C-WAGS Obedience levels - 5 minutes each
      [Constants.dog_class_element_level.cwags_obedience_level_1]: 5,
      [Constants.dog_class_element_level.cwags_obedience_level_2]: 5,
      [Constants.dog_class_element_level.cwags_obedience_level_3]: 5,
      [Constants.dog_class_element_level.cwags_obedience_level_4]: 5,
      [Constants.dog_class_element_level.cwags_obedience_level_5]: 5,
    },
    [Constants.show_type.rally_obedience]: {
      // C-WAGS Rally levels - 5 minutes each
      [Constants.dog_class_element_level.cwags_rally_starter]: 5,
      [Constants.dog_class_element_level.cwags_rally_advanced]: 5,
      [Constants.dog_class_element_level.cwags_rally_pro]: 5,
      [Constants.dog_class_element_level.cwags_rally_zoom_1]: 5,
      [Constants.dog_class_element_level.cwags_rally_zoom_1_5]: 5,
      [Constants.dog_class_element_level.cwags_rally_zoom_2]: 5,
      [Constants.dog_class_element_level.cwags_rally_arf]: 5,
    },
    // C-WAGS Games — keyed by level (shared by all game elements). Course time
    // limit is 2 min (3 max) for Colors / Black Jack / Pairs, 3 min (4 max) for
    // Team; 5 min per run is consistent with the other C-WAGS classes.
    [Constants.show_type.cwags_games]: {
      [Constants.dog_class_element_level.cwags_games_level_1]: 5,
      [Constants.dog_class_element_level.cwags_games_level_2]: 5,
      [Constants.dog_class_element_level.cwags_games_level_3]: 5,
      [Constants.dog_class_element_level.cwags_games_level_4]: 5,
      [Constants.dog_class_element_level.cwags_games_zoom_1]: 5,
      [Constants.dog_class_element_level.cwags_games_zoom_1_5]: 5,
      [Constants.dog_class_element_level.cwags_games_zoom_2]: 5,
    },
  },
  [Constants.sanctioning_club.FH]: {
    [Constants.show_type.rally_obedience]: {
      [Constants.dog_class_element_level.fh_rally_foundation_3_7]:    3,
      [Constants.dog_class_element_level.fh_rally_foundation_8_up]:   3,
      [Constants.dog_class_element_level.fh_rally_novice_3_7]:        3,
      [Constants.dog_class_element_level.fh_rally_novice_8_up]:       3,
      [Constants.dog_class_element_level.fh_rally_intermediate_3_7]:  3,
      [Constants.dog_class_element_level.fh_rally_intermediate_8_up]: 3,
      [Constants.dog_class_element_level.fh_rally_advanced_3_7]:      3,
      [Constants.dog_class_element_level.fh_rally_advanced_8_up]:     3,
      [Constants.dog_class_element_level.fh_rally_excellent]:         3,
      [Constants.dog_class_element_level.fh_rally_masters]:           3,
    },
    [Constants.show_type.agility]: {
      [Constants.dog_class_element.fh_agility_jtt]:                           5,
      [Constants.dog_class_element.fh_agility_standard_no_weaves]:            5,
      [Constants.dog_class_element.fh_agility_standard_with_weaves]:          5,
      [Constants.dog_class_element.fh_agility_advanced_standard_with_weaves]: 5,
      [Constants.dog_class_element.fh_agility_advanced_jumpers_no_weaves]:    5,
    },
  },
  [Constants.sanctioning_club.ASFA]: {
    [Constants.show_type.field_trial]: {
      [Constants.dog_class_element.asfa_stakes]: {
        [Constants.dog_class_element_level.asfa_open]: 2.4,
        [Constants.dog_class_element_level.asfa_fch]: 2.4,
        [Constants.dog_class_element_level.asfa_veteran]: 2.4,
        [Constants.dog_class_element_level.asfa_singles]: 2.4,
        [Constants.dog_class_element_level.asfa_provisional]: 2.4,
      },
      [Constants.dog_class_element.asfa_additional_stakes]: {
        [Constants.dog_class_element_level.asfa_kennel]: 2.4,
        [Constants.dog_class_element_level.asfa_breeder]: 2.4,
        [Constants.dog_class_element_level.asfa_bench]: 2.4,
      },
    },
  },
  [Constants.sanctioning_club.BHA]: {
    [Constants.show_type.barn_hunt]: {
      // All Barn Hunt levels - 5 minutes each
      [Constants.dog_class_element_level.barn_hunt_instinct]: 5,
      [Constants.dog_class_element_level.barn_hunt_novice]: 5,
      [Constants.dog_class_element_level.barn_hunt_open]: 5,
      [Constants.dog_class_element_level.barn_hunt_senior]: 5,
      [Constants.dog_class_element_level.barn_hunt_master]: 5,
      [Constants.dog_class_element_level.barn_hunt_crazy_8s]: 5,
      [Constants.dog_class_element_level.barn_hunt_line_drive]: 5,
    },
  },
};

// Helper to normalize show element names to constant keys
// Converts display names like "Standard" to keys like "standard"
const normalizeShowElement = (showElement?: string): string => {
  if (!showElement) return "";
  
  // Convert to lowercase and replace spaces/special chars with underscores
  return showElement
    .toLowerCase()
    .replace(/\s*\([^)]*\)/g, "") // Remove parentheses and content
    .replace(/\s+/g, "_")          // Replace spaces with underscores
    .replace(/[^a-z0-9_]/g, "")    // Remove non-alphanumeric except underscores
    .replace(/_+/g, "_")           // Collapse multiple underscores
    .replace(/^_|_$/g, "");        // Remove leading/trailing underscores
};

export const getRunningTimeMinutes = (
  sanctioningClub: string,
  showType: string,
  showElement?: string,
  level?: string
): number => {
  // Normalize the show element to handle both constant keys and display names
  const normalizedElement = normalizeShowElement(showElement);
  const normalizedLevel = normalizeShowElement(level);
  
  // Try with level directly (for non-nested structure)
  const levelValue = ElementRunningTimes[sanctioningClub]?.[showType]?.[level || ""];
  if (typeof levelValue === 'number') return levelValue;
  
  // Try with normalized level (for non-nested structure)
  const normalizedLevelValue = ElementRunningTimes[sanctioningClub]?.[showType]?.[normalizedLevel || ""];
  if (typeof normalizedLevelValue === 'number') return normalizedLevelValue;
  
  // Try with original showElement first (in case it's already the correct key)
  let elementLevelValue = ElementRunningTimes[sanctioningClub]?.[showType]?.[showElement || ""]?.[level || ""];
  if (typeof elementLevelValue === 'number') return elementLevelValue;
  
  // Try with normalized showElement (handles display names)
  elementLevelValue = ElementRunningTimes[sanctioningClub]?.[showType]?.[normalizedElement]?.[level || ""];
  if (typeof elementLevelValue === 'number') return elementLevelValue;
  
  // Try with normalized showElement and normalized level
  elementLevelValue = ElementRunningTimes[sanctioningClub]?.[showType]?.[normalizedElement]?.[normalizedLevel || ""];
  if (typeof elementLevelValue === 'number') return elementLevelValue;
  
  // Try showType directly (for show-level defaults like UKC Conformation)
  const showTypeValue = ElementRunningTimes[sanctioningClub]?.[showType];
  if (typeof showTypeValue === 'number') return showTypeValue;
  
  // Default to 2.4 for AKC Conformation classes when no match found
  if (sanctioningClub === Constants.sanctioning_club.AKC && showType === Constants.show_type.conformation) {
    return 2.4;
  }
  
  return 0;
};

/**
 * Returns the BHA MRV run-value multiplier for a given level.
 * Run Value = 1 entry × multiplier. Falls back to 1.0 for unrecognised levels.
 * Use when waitlist_option === Constants.waitlist_options.daily_judge_mrv_limit.
 */
export const getMrvRunValue = (level?: string): number => {
  if (!level) return 1.0;
  const multipliers: Record<string, number> = Constants.bha_mrv_multipliers as any;
  // Try the level string directly (e.g. "Instinct"), then normalise to constant key
  const key = level.toLowerCase().replace(/\s+/g, "_").replace(/[^a-z0-9_]/g, "");
  // Check prefixed key first (barn_hunt_instinct), then plain key
  return (
    multipliers[`barn_hunt_${key}`] ??
    multipliers[key] ??
    1.0
  );
};
